import { Button } from "antd";
import { SaveBtn } from "components/Icon";

const MediActionSave = (props) => {
  const handleClick = (e) => {
    if (props.onClick) {
      props.onClick(e);
    }
  };

  return (
    <Button
      {...props}
      icon={<SaveBtn color="#8D8D8D" />}
      onClick={handleClick}
      type="text"
    >
      {props.children}
    </Button>
  );
};

export default MediActionSave;
